import { render, staticRenderFns } from "./EdcsaComponent.vue?vue&type=template&id=001f9abc&"
import script from "./EdcsaComponent.vue?vue&type=script&lang=ts&"
export * from "./EdcsaComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('001f9abc')) {
      api.createRecord('001f9abc', component.options)
    } else {
      api.reload('001f9abc', component.options)
    }
    module.hot.accept("./EdcsaComponent.vue?vue&type=template&id=001f9abc&", function () {
      api.rerender('001f9abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/EdcsaComponent.vue"
export default component.exports